
  <!--
 * 横版
 * @LastEditTime: Mon Feb 17 2025 18:24:03 GMT+0800 (中国标准时间)
 -->
  <template>
  <div id="u_r_0J3316" :class="[curLang]" class="u_r_0J3316 route-index"  ><u_c_3AAA17></u_c_3AAA17><u_c_H25469></u_c_H25469><u_c_7NTW17></u_c_7NTW17><u_c_V3GG18></u_c_V3GG18><u_c_PU3219></u_c_PU3219><u_c_JDH534></u_c_JDH534><u_c_699X21></u_c_699X21></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_3AAA17 from "@/components/u_c_3AAA17.vue";import u_c_H25469 from "@/components/u_c_H25469.vue";import u_c_7NTW17 from "@/components/u_c_7NTW17.vue";import u_c_V3GG18 from "@/components/u_c_V3GG18.vue";import u_c_PU3219 from "@/components/u_c_PU3219.vue";import u_c_JDH534 from "@/components/u_c_JDH534.vue";import u_c_699X21 from "@/components/u_c_699X21.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"en-US":{},"ru-RU":{},"pt-PT":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['en-US']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    const init = inject('init', () => {});

if (window.innerWidth < window.innerHeight && router.hasRoute('m')) {
  let routerCount = router.router.getRoutes().length;
  if (routerCount < 3) {
    init();
  } else {
    router.gotoRouter('/m');
  }
} else {
  init();
}
    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>

.en-US ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;
line-height:normal;

}

.en-US ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.en-US ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.ru-RU ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;
line-height:normal;

}

.ru-RU ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.ru-RU ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.pt-PT ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;
line-height:normal;

}

.pt-PT ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.pt-PT ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.default ::v-deep(.normal .page-common-btn){
font-size:2.40vw;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;
line-height:normal;

}

.default ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.default ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
</style>
